module.exports = __webpack_public_path__ + "img/GDKL10.png";